export enum RetificacaoAtendimentoOpcaoEnum {
  EDITAR_REGISTRO = 'EDITAR_REGISTRO',
  REMOVER_REGISTRO = 'REMOVER_REGISTRO',
}

export interface RetificacaoAtendimentoModel {
  id: ID
  tipo: RetificacaoAtendimentoOpcaoEnum
  justificativa: string
}

export interface RetificacaoAtendimentoButtonModel {
  profissional?: {
    id: string
  }
  cbo?: {
    id: string
  }
  unidadeSaude?: {
    id: string
  }
  equipe?: {
    id: string
  }
  isInativo: boolean
  isVersaoFichaRetificavel: boolean
}
